import React from 'react';

import VimeoSearchResult from './VimeoSearchResult.react';

export default class VimeoSearchResultList extends React.Component {
	static propTypes = {
		searchResultList: React.PropTypes.object.isRequired,
		onPick: React.PropTypes.func.isRequired
	};

	render() {
		const {searchResultList, onPick} = this.props;

		return (
			<div className="pixabay-search-result">
				{searchResultList.map((searchResult) => <VimeoSearchResult key={searchResult.video_id} searchResult={searchResult} onPick={() => onPick(searchResult)} />)}
			</div>
		);
	}
}
